/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Marquee3k; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Marquee3k = function () {
  function Marquee3k(element, options) {
    _classCallCheck(this, Marquee3k);

    this.element = element;
    this.selector = options.selector;
    this.speed = element.dataset.speed || 0.25;
    this.pausable = element.dataset.pausable;
    this.reverse = element.dataset.reverse;
    this.paused = false;
    this.parent = element.parentElement;
    this.parentProps = this.parent.getBoundingClientRect();
    this.content = element.children[0];
    this.innerContent = this.content.innerHTML;
    this.wrapStyles = '';
    this.offset = 0;

    this._setupWrapper();
    this._setupContent();
    this._setupEvents();

    this.wrapper.appendChild(this.content);
    this.element.appendChild(this.wrapper);
  }

  _createClass(Marquee3k, [{
    key: '_setupWrapper',
    value: function _setupWrapper() {
      this.wrapper = document.createElement('div');
      this.wrapper.classList.add('marquee3k__wrapper');
      this.wrapper.style.whiteSpace = 'nowrap';
    }
  }, {
    key: '_setupContent',
    value: function _setupContent() {
      this.content.classList.add(this.selector + '__copy');
      this.content.style.display = 'inline-block';
      this.contentWidth = this.content.offsetWidth;

      this.requiredReps = this.contentWidth > this.parentProps.width ? 2 : Math.ceil((this.parentProps.width - this.contentWidth) / this.contentWidth) + 1;

      for (var i = 0; i < this.requiredReps; i++) {
        this._createClone();
      }

      if (this.reverse) {
        this.offset = this.contentWidth * -1;
      }

      this.element.classList.add('is-init');
    }
  }, {
    key: '_setupEvents',
    value: function _setupEvents() {
      var _this = this;

      this.element.addEventListener('mouseenter', function () {
        if (_this.pausable) _this.paused = true;
      });

      this.element.addEventListener('mouseleave', function () {
        if (_this.pausable) _this.paused = false;
      });
    }
  }, {
    key: '_createClone',
    value: function _createClone() {
      var clone = this.content.cloneNode(true);
      clone.style.display = 'inline-block';
      clone.classList.add(this.selector + '__copy');
      this.wrapper.appendChild(clone);
    }
  }, {
    key: 'animate',
    value: function animate() {
      if (!this.paused) {
        var isScrolled = this.reverse ? this.offset < 0 : this.offset > this.contentWidth * -1;
        var direction = this.reverse ? -1 : 1;
        var reset = this.reverse ? this.contentWidth * -1 : 0;

        if (isScrolled) this.offset -= this.speed * direction;else this.offset = reset;

        this.wrapper.style.whiteSpace = 'nowrap';
        this.wrapper.style.transform = 'translate(' + this.offset + 'px, 0) translateZ(0)';
      }
    }
  }, {
    key: '_refresh',
    value: function _refresh() {
      this.contentWidth = this.content.offsetWidth;
    }
  }, {
    key: 'repopulate',
    value: function repopulate(difference, isLarger) {
      this.contentWidth = this.content.offsetWidth;

      if (isLarger) {
        var amount = Math.ceil(difference / this.contentWidth) + 1;

        for (var i = 0; i < amount; i++) {
          this._createClone();
        }
      }
    }
  }], [{
    key: 'refresh',
    value: function refresh(index) {
      MARQUEES[index]._refresh();
    }
  }, {
    key: 'refreshAll',
    value: function refreshAll() {
      for (var i = 0; i < MARQUEES.length; i++) {
        MARQUEES[i]._refresh();
      }
    }
  }, {
    key: 'init',
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { selector: 'marquee3k' };

      window.MARQUEES = [];
      var marquees = Array.from(document.querySelectorAll('.' + options.selector));
      var previousWidth = window.innerWidth;
      var timer = void 0;

      for (var i = 0; i < marquees.length; i++) {
        var marquee = marquees[i];
        var instance = new Marquee3k(marquee, options);
        MARQUEES.push(instance);
      }

      animate();

      function animate() {
        for (var _i = 0; _i < MARQUEES.length; _i++) {
          MARQUEES[_i].animate();
        }
        window.requestAnimationFrame(animate);
      }

      window.addEventListener('resize', function () {
        clearTimeout(timer);

        timer = setTimeout(function () {
          var isLarger = previousWidth < window.innerWidth;
          var difference = window.innerWidth - previousWidth;

          for (var _i2 = 0; _i2 < MARQUEES.length; _i2++) {
            MARQUEES[_i2].repopulate(difference, isLarger);
          }

          previousWidth = _this2.innerWidth;
        });
      }, 250);
    }
  }]);

  return Marquee3k;
}();

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VideoPlayer = function () {
  function VideoPlayer(items) {
    var _this = this;

    _classCallCheck(this, VideoPlayer);

    this.items = Array.from(items);

    this.togglePlayPause = this.togglePlayPause.bind(this);
    this.changeButtonType = this.changeButtonType.bind(this);
    this.updateProgress = this.updateProgress.bind(this);
    this.seek = this.seek.bind(this);

    this.items.forEach(function (item) {
      var video = item.getElementsByClassName('js-media-video')[0];
      var btn = item.getElementsByClassName('js-play-pause-button')[0];
      var icon = btn.querySelector('img');
      var progressBar = item.getElementsByClassName('js-progress-bar')[0];
      var progressText = item.getElementsByClassName('js-progress-text')[0];
      var remainingTime = item.getElementsByClassName('js-remaining-time')[0];

      video.controls = false;

      video.addEventListener('timeupdate', function () {
        _this.updateProgress(video, progressBar, remainingTime);
      });

      video.addEventListener('touchend', function (e) {
        e.preventDefault();
        _this.togglePlayPause(btn, icon, video);
      });
      btn.addEventListener('touchend', function (e) {
        e.preventDefault();
        _this.togglePlayPause(btn, icon, video);
      });

      video.addEventListener('click', function () {
        _this.togglePlayPause(btn, icon, video);
      }, { passive: true });
      btn.addEventListener('click', function () {
        _this.togglePlayPause(btn, icon, video);
      }, { passive: true });
      progressText.addEventListener('click', function (e) {
        _this.seek(e, video, progressBar);
      }, { passive: true });

      // For firefox users who right click to control
      video.addEventListener('play', function () {
        _this.changeButtonType(btn, icon, '/images/pause.svg', 'pause');
      }, false);

      // For firefox users who right click to control
      video.addEventListener('pause', function () {
        _this.changeButtonType(btn, icon, '/images/right-arrow.svg', 'play');
      }, false);
    });
  }

  _createClass(VideoPlayer, [{
    key: 'togglePlayPause',
    value: function togglePlayPause(btn, icon, video) {
      if (video.paused || video.ended) {
        this.changeButtonType(btn, icon, '/images/pause.svg', 'pause');
        video.play();
      } else {
        this.changeButtonType(btn, icon, '/images/right-arrow.svg', 'play');
        video.pause();
      }
    }
  }, {
    key: 'changeButtonType',
    value: function changeButtonType(btn, icon, iconSrc, value) {
      btn.title = value;
      icon.src = iconSrc;
    }
  }, {
    key: 'updateProgress',
    value: function updateProgress(video, progressBar, remainingTime) {
      var timeLeft = video.duration - video.currentTime;
      var minRemaining = parseInt(timeLeft / 60, 10);
      var secondsRemaining = String(Math.round(timeLeft % 60)).padStart(2, 0);
      var displayTime = minRemaining + ':' + secondsRemaining;
      var percentage = Math.floor(100 / video.duration * video.currentTime);

      if (!remainingTime) {
        return;
      }

      remainingTime.innerText = displayTime;
      progressBar.value = percentage;
    }
  }, {
    key: 'seek',
    value: function seek(e, video, progressBar) {
      var padding = 16;

      var percent = (e.offsetX + padding) / progressBar.offsetWidth;
      video.currentTime = percent * video.duration;
      progressBar.value = percent / 100;
    }
  }]);

  return VideoPlayer;
}();

new VideoPlayer(document.getElementsByClassName('js-media-player'));

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_videoPlayer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_videoPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modules_videoPlayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_marquee3000__ = __webpack_require__(3);



window.onload = function () {
    var header = document.getElementById('js-header-marquee');
    var screenWidth = window.screen.availWidth;

    if (screenWidth <= 767) {
        header.classList.add('marquee3k');
        __WEBPACK_IMPORTED_MODULE_1__modules_marquee3000__["a" /* Marquee3k */].init();
        return;
    } else {
        __WEBPACK_IMPORTED_MODULE_1__modules_marquee3000__["a" /* Marquee3k */].init();
    }
};

var currentExtraContent = null;
var showExtraContent = function showExtraContent(item) {
    var extraId = item.getAttribute('data-extra-id');

    if (currentExtraContent) {
        var _videos = currentExtraContent.querySelectorAll('video');
        if (_videos) {
            _videos.forEach(function (video) {
                video.pause();
            });
        }
        currentExtraContent.style.display = "none";
    }

    currentExtraContent = document.getElementById(extraId);

    if (currentExtraContent) {
        var _videos2 = currentExtraContent.querySelectorAll('video');
        if (_videos2) {
            _videos2.forEach(function (video) {
                var url = video.getAttribute('data-src');
                video.src = url;
                video.play();
            });
        }
        currentExtraContent.style.display = "inline-block";
        currentExtraContent.scrollIntoView({ inline: "center" });
    }
};

var currentVideo = null;
var showVideo = function showVideo(item) {
    var videoId = item.getAttribute('data-video-id');

    if (currentVideo) {
        currentVideo.pause();

        // if video is already playing, set it back to null so it will pause
        if (currentVideo == document.getElementById(videoId)) {
            currentVideo = null;
            return;
        }
    }

    currentVideo = document.getElementById(videoId);

    if (currentVideo) {
        var url = currentVideo.getAttribute('data-src');
        currentVideo.src = url;
        currentVideo.play();
    }
};

var playAudio = function playAudio(e) {
    var audio = document.getElementById('js-audio');
    var icon = e.currentTarget.querySelector('img');

    if (audio.paused || audio.ended) {
        icon.src = '/images/pause.svg';
        audio.play();
    } else {
        icon.src = '/images/right-arrow.svg';
        audio.pause();
    }
};

var videos = document.querySelectorAll('.js-media-player');
videos.forEach(function (item) {
    item.addEventListener('touchend', function (e) {
        e.preventDefault();
        showVideo(item);
    });

    item.addEventListener('click', function () {
        return showVideo(item);
    });
});

var people = document.querySelectorAll('.js-people');
people.forEach(function (item) {
    item.addEventListener('touchend', function (e) {
        e.preventDefault();
        showExtraContent(item);
    });

    item.addEventListener('click', function () {
        return showExtraContent(item);
    });
});

var audioPlayer = document.getElementById('js-play');
audioPlayer.addEventListener('click', function (e) {
    playAudio(e);
});

audioPlayer.addEventListener('touchend', function (e) {
    e.preventDefault();
    playAudio(e);
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.95d196fc26e2c2ecbf73.js